// extracted by mini-css-extract-plugin
export var collapsedSummary = "_qw-0";